import { Button, Form, Input } from 'antd';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminOTPVerifyService } from '../../../../services/login/Login.api';
import { AdminContext } from '../../../contexts/adminContext/adminContext';
import DefaultModal from '../../../customer/components/modals/defaultModal/DefaultModal';
import formSetDynamicErrors from '../../../../utils/functions/formSetDynamicErrors';

function AdminOtpVerifyModal({ verifyModal, setVerifyModal }) {
  const [form] = Form.useForm();
  const adminContext = useContext(AdminContext);
  const navigate = useNavigate();
  const { data, show } = verifyModal;

  const handleClose = () => {
    setVerifyModal({
      show: false,
    });
  };

  const handleConfirm = async () => {
    try {
      const res = await adminOTPVerifyService({
        verification_code: form.getFieldValue('verification_code'),
        username: data?.username,
      });
      if (res?.data?.status === 'success') {
        adminContext.setUser({}, res?.data?.token);
        navigate('/admin');
        handleClose();
      }
    } catch (e) {
      formSetDynamicErrors({ form, e });
    }
  };

  return (
    <DefaultModal
      show={show}
      setShow={handleClose}
      className="ticket-refund-modal"
    >
      <div className="flex flex-col gap-5">
        <h3 className="text-center">
          შეიყვანეთ მეილზე მიღებული კოდი
        </h3>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleConfirm}
        >

          <Form.Item
            label="კოდი"
            name="verification_code"
            rules={[
              {
                required: true,
                message: 'შეიყვანეთ კოდი',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <div className="flex justify-center">
            <Button
              type="primary"
              htmlType="submit"
            >
              დადასტურება
            </Button>
          </div>
        </Form>

      </div>
    </DefaultModal>
  );
}

export default AdminOtpVerifyModal;
